import React from "react";
import { Box, Container, Stack, Typography } from "@mui/material";
import { equals } from "ramda";

import { pricingCardsData } from "src/widgets/WBPricing/model/constants";
import { PricingCards } from "src/widgets/WBPricing/config/types";

import backgroundImage from "../assets/background.webp";

import { Card } from "./Card/Card";

export const WbPricing: React.FC = () => {
  return (
    <Stack
      width={1}
      justifyContent="flex-start"
      alignItems="center"
      direction="column"
      gap={2}
      sx={{
        marginTop: { md: 12, sm: 8, xs: 4 },
        marginBottom: { md: 40, xs: 0 },
        transform: { md: 0, xs: "translateY(50px)" },
      }}
    >
      <Typography
        color="text.secondary"
        variant="h5"
        textTransform="uppercase"
        fontWeight={300}
      >
        Pricing
      </Typography>

      <Typography
        maxWidth={0.7}
        color="text.primary"
        variant="body1"
        textAlign="center"
        sx={{
          fontSize: {
            sm: "1rem",
            xs: "0.875rem",
          },
        }}
      >
        Find the right plan to enhance your communication and automate your
        workflow. Start for free or choose a plan to unlock your full potential.
      </Typography>

      <Stack width={1} direction="row" position="relative" gap={12}>
        <Container
          maxWidth="xl"
          sx={{
            width: 1,
            height: "calc(100% + 60px)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            flexWrap: { md: "nowrap", xs: "wrap" },
            gap: { xl: 12, lg: 8, sm: 4, xs: 4 },
          }}
        >
          {Object.keys(pricingCardsData).map((key: PricingCards) => {
            const cardData = pricingCardsData[key];

            return (
              <Card
                key={key}
                cardData={cardData}
                sx={{
                  transform: {
                    md: "none",
                    xs: equals(key, PricingCards.ENTERPRISE)
                      ? "translateY(-40%)"
                      : "",
                  },
                  flexBasis: {
                    md: "calc(33.3% - 32px)",
                    xs: "calc(50% - 32px)",
                  },
                  marginTop: {
                    md: equals(key, PricingCards.PRO) ? 12 : 0,
                    xs: 0,
                  },
                }}
              />
            );
          })}
        </Container>

        <Box
          sx={{
            width: 1,
            display: { md: "flex", xs: "none" },
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            height: 600,
            overflow: "hidden",
            transform: "translateY(90%)",
          }}
        >
          <img width="100%" src={backgroundImage} alt="Background image" />
        </Box>
      </Stack>
    </Stack>
  );
};
